module.exports = __webpack_public_path__ + "img/reference-lebensraum.41992c57.webp";